import { Component } from '@angular/core';
import { HeaderComponent } from '../plantilla/header/header.component';
import { FooterComponent } from '../plantilla/footer/footer.component';
import { HeroComponent } from '../hero/hero.component';
import { HistoriaComponent } from '../historia/historia.component';
import { ActionCallComponent } from '../action-call/action-call.component';
import { FeaturedInsuranceComponent } from '../dive-insurance/featured-insurance/featured-insurance.component';
import { MainGalleryComponent } from '../gallery/main-gallery/main-gallery.component';
import { MapaComponent } from '../mapa/mapa.component';
import { FoodGalleryComponent } from "../gallery/food-gallery/food-gallery.component";
import { ReviewsComponent } from "../reviews/reviews.component";
import { ScheduleRestaurantComponent } from "../schedule-restaurant/schedule-restaurant.component";

@Component({
  selector: 'app-inicio',
  standalone: true,
  imports: [
    HeaderComponent,
    FooterComponent,
    HeroComponent,
    HistoriaComponent,
    ActionCallComponent,
    FeaturedInsuranceComponent,
    MainGalleryComponent,
    MapaComponent,
    FoodGalleryComponent,
    FoodGalleryComponent,
    ReviewsComponent,
    ScheduleRestaurantComponent
],
  templateUrl: './inicio.component.html',
  styleUrl: './inicio.component.scss',
})
export class InicioComponent {}
